
export const formattedPrice=(price)=>{
return Math.floor(price) === price
? price
: price.toString().split(".")[1].length > 3
? parseFloat(price.toFixed(3))
: price;
}